import { httpUtil } from './httpUtil';

const querystring = require('querystring');

//  let mwCignalUrl = "https://mwcignaluat.crm.com/mwapi"
let mwCignalUrl = document._portalConfig.urlMW ? document._portalConfig.urlMW : null;
let apiKeyMV = document._portalConfig.apiKeyMW ? document._portalConfig.apiKeyMW : null;

export const cignalservices = {
    initiateTopUp,
    getTopUpResult,
    initiateOrder,
    initiatePayment,
    estimateAllowance,
    generatePass,
    getPassPlans,
    makeOrder,
    getOrder,
    usageData,
    subscriptionDevices,
    getMerchantUserType,
    getMerchantAccount,
    getProducts,
    onMerchantSearchCustomers,
    onMerchantMakeOrder,
    getMerchantOrdersHistory,
    getMerchantOrderDetail,
    getMerchantAccountTransactions,
    getMerchantDealers,
    onMerchantTopupDealer,
    getMerchantTopupDetail,
    onMerchantChangePassword,
    getMerchantAccountStatements,
    getMerchantAccountStatementDetail,
    onMerchantCreateDealer,
};

async function initiateTopUp({
    customer_id,
    first_name,
    last_name,
    amount,
    redirect_url_success,
    redirect_url_failure,
    redirect_url_cancel
} = {}) {
    try {
        const response = await post({
            resourcePath: '/initiate_topup',
            body: {
                customer_id,
                first_name,
                last_name,
                amount,
                redirect_url_success,
                redirect_url_failure,
                redirect_url_cancel
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getTopUpResult({
    request_reference_number
} = {}) {
    try {
        const response = await get({
            resourcePath: '/topup_result',
            queryParams: {
                request_reference_number
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}
async function getPassPlans() {
    try {
        const response = await get({
            resourcePath: '/pass_plans',
            queryParams: null
        })
        return response;
    } catch (ex) {
        return ex;
    }
}
async function initiateOrder(body){
    try {
        const response = await post({
            resourcePath: '/initiate_order',
            body: {...body}
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function initiatePayment({
    customer_id,
    first_name,
    last_name,
    amount,
    redirect_url_success,
    redirect_url_failure,
    redirect_url_cancel
} = {}) {
    try {
        const response = await post({
            resourcePath: '/initiate_payment',
            body: {
                customer_id,
                first_name,
                last_name,
                amount,
                redirect_url_success,
                redirect_url_failure,
                redirect_url_cancel
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function estimateAllowance() {
    try {
        var contact_id = httpUtil.getSession().sub;
        var organisation_id = await httpUtil.getOrganisation();
        const response = await post({
            resourcePath: '/estimate_allowance',
            body: {
                contact_id: contact_id,
                organisation_id: organisation_id
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function generatePass({
    pass_plan,
    recipient
} = {}) {
    try {
        var contact_id = httpUtil.getSession().sub;
        var email = httpUtil.getSession().email;
        var name = httpUtil.getSession().full_name;
        if (recipient == null){
            recipient = {
                name: name,
                email: email
            }
        }
        var organisation_id = await httpUtil.getOrganisation();
        const response = await post({
            resourcePath: '/generate_pass',
            body: {
                contact_id: contact_id,
                organisation_id: organisation_id,
                pass_plan,
                recipient
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function makeOrder({
    account_id,
    wallet_id,
    product_id
} = {}) {
    try {
        const response = await post({
            resourcePath: '/order',
            body: {
                account_id,
                wallet_id,
                product_id
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getOrder(orderId) {
    try {
        const response = await get({
            resourcePath: '/order',
            queryParams:{
                order_id: orderId
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function usageData(service_id){
    try {
        var contact_id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/usage_data',
            body: {
                contact_id: contact_id,
                service_id: service_id,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function subscriptionDevices(){
    try {
        let id = httpUtil.getSession().sub;
        const response = await get({
            resourcePath: '/subscription_devices',
            queryParams: {
                contact_id: id
            },
        });
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getMerchantUserType(org_id) {
    try {
        let orgId = await httpUtil.getOrganisation();
        const response = await get({
            resourcePath: '/merchant/user_type',
            queryParams:{
                org_id: org_id ? org_id : orgId,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getMerchantAccount(org_id) {
    try {
        let orgId = await httpUtil.getOrganisation();
        const response = await get({
            resourcePath: '/merchant/account',
            queryParams:{
                org_id: org_id ? org_id : orgId,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getMerchantDealers({
    group_id,
    primary_org_id,
    org_id,
}) {
    try {
        let orgId = await httpUtil.getOrganisation();
        if(!org_id) org_id = orgId;
        const response = await get({
            resourcePath: '/merchant/dealers',
            queryParams:{
                primary_org_id: primary_org_id,
                group_id: group_id,
                org_id: org_id,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getProducts({
    org_id,
}) {
    try {
        const response = await get({
            resourcePath: '/merchant/products',
            queryParams: {
                org_id: org_id,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function onMerchantSearchCustomers(search_value) {
    try {
        const response = await get({
            resourcePath: '/merchant/customers',
            queryParams: {
                search_value: search_value,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function onMerchantMakeOrder({
    account_id,
    customer_id,
    total_amount,
    org_id,
    line_items,
    customer_name,
    customer_code,
    tp_dealer_email,
    user_email,
} = {}) {
    try {
        let orgId = await httpUtil.getOrganisation();
        if(!org_id) org_id = orgId;
        const response = await post({
            resourcePath: '/merchant/orders',
            body: {
                account_id,
                customer_id,
                org_id: orgId,
                total_amount,
                line_items,
                customer_name,
                customer_code,
                tp_dealer_email,
                user_email,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getMerchantOrdersHistory({
    page = 1,
    size = 10,
}) {
    try {
        let orgId = await httpUtil.getOrganisation();
        const response = await get({
            resourcePath: '/merchant/orders',
            queryParams: {
                page,
                size,
                org_id: orgId,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getMerchantOrderDetail(orderId) {
    try {
        const response = await get({
            resourcePath: '/merchant/orders/' + orderId,
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getMerchantAccountTransactions({
    page = 1,
    size = 10,
    account_id,
}) {
    try {
        const response = await get({
            resourcePath: '/merchant/topup',
            queryParams: {
                page,
                size,
                account_id: account_id,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function onMerchantTopupDealer({
    tp_account_id,
    dealer_id,
    amount,
    dealer_email,
    dealer_name,
    tp_name,
    tp_email,
} = {}) {
    try {
        let body = {
            dealer_id,
            tp_account_id,
            amount,
        }
        if(dealer_email) body.dealer_email = dealer_email;
        if(tp_name) body.tp_name = tp_name;
        if(tp_email) body.tp_email = tp_email;
        if(dealer_name) body.dealer_name = dealer_name;
        
        const response = await post({
            resourcePath: '/merchant/topup',
            body: body
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getMerchantTopupDetail(id) {
    try {
        const response = await get({
            resourcePath: '/merchant/topup/' + id,
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function onMerchantChangePassword({
    current_password,
    new_password,
    user_token
} = {}) {
    try {
        let id = await httpUtil.getSession().sub;
        const response = await put({
            resourcePath: '/merchant/user/' + id + "/change_password",
            body: {
                current_password, 
                new_password,
                user_token: user_token,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getMerchantAccountStatements({
    account_id,
    from_month,
    to_month,
    from_year,
    to_year,
    org_id,
}) {
    try {
        let orgId = await httpUtil.getOrganisation();
        if(!org_id) org_id = orgId;
        const response = await get({
            resourcePath: '/merchant/account_statement',
            queryParams: {
                account_id: account_id,
                org_id: org_id,
                from_month,
                to_month,
                from_year,
                to_year,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getMerchantAccountStatementDetail({
    account_id,
    from_month,
    to_month,
    from_year,
    to_year,
    org_id,
}) {
    try {
        let orgId = await httpUtil.getOrganisation();
        if(!org_id) org_id = orgId;
        const response = await get({
            resourcePath: '/merchant/account_statement_detail',
            queryParams: {
                account_id: account_id,
                org_id: org_id,
                from_month,
                to_month,
                from_year,
                to_year,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function onMerchantCreateDealer({
    dealer_first_name,
    dealer_last_name,
    dealer_email,
    cignal_org_id,
    tp_group_id,
    dealer_phone,
    country_code,
} = {}) {
    try {
        const response = await post({
            resourcePath: '/merchant/dealers',
            body: {
                dealer_first_name,
                dealer_last_name,
                tp_group_id,
                dealer_email,
                cignal_org_id,
                dealer_phone,
                country_code,
            }
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

function createOption() {
    var options = {};
    options.headers = {
        'User-Agent': 'request',
        'Content-Type': 'application/json; charset=utf-8',
        'api_key': apiKeyMV,
    };
    return options;
}

function cleanObj(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
}

function json2Obj(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}

function getURI(resourcePath) {
    return mwCignalUrl + resourcePath;
}

async function get({
    resourcePath,
    queryParams
}) {
    try {
        var options = createOption();
        options.method = 'GET';
        options.headers['x_token'] = httpUtil.getToken();
        let uri = getURI(resourcePath);
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));;
        console.log("GET uri:", uri);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("AAAA e:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function post({
    resourcePath,
    body,
}) {
    try {
        var options = createOption();
        options.method = 'POST';
        options.headers['x_token'] = httpUtil.getToken();
        let uri = getURI(resourcePath);
        if (body)
            options.body = JSON.stringify(body);
        console.log("GET uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("post exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function put({
    resourcePath,
    body,
}) {
    try {
        var options = createOption();
        options.method = 'PUT';
        options.headers['x_token'] = httpUtil.getToken();
        let uri = getURI(resourcePath);
        if (body)
            options.body = JSON.stringify(body);
        console.log("GET uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("put exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}
